import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './index.scss';
import { Header, Icon } from 'semantic-ui-react';
import { OfficeViewContainer, OfficeViewHeader, OfficeViewLeftPanel, OfficeViewDialPad, generateResolver, yup, OfficeViewPhoneMiddle, OfficeViewCompanyDestinations, OfficeViewTeams, Notification, STATUS_TYPES, OfficeViewRecents, VALIDATORS, Modal, DateTimeUtils, productRestriction, PRODUCT_PERMISSIONS } from 'dyl-components';
import { useForm } from 'react-hook-form';
import officeView from 'actions/office_view';
import callTypes from "actions/office_view/types";
import contactsActions from 'actions/contacts';
import callActions from 'actions/call'
import pbxConfigActions from 'actions/pbx_config';
import userActions from 'actions/user';
import SendEmailModal from 'shared/modals/SendEmailModal';
import AddTaskModal from 'shared/modals/AddTaskModal';
import useTaskForm from 'utils/useTaskForm';
import oauthActions from 'actions/oauth';
import eventActions from "actions/event";
import groupsActions from "actions/groups";
import eventAttendeeActions from "actions/event_attendee";
import eventAttachmentActions from "actions/event_attachment";
import accountActions from 'actions/account';
import uploadActions from "actions/upload";
import officeViewActions from "actions/office_view";
import AddEventModal from 'shared/modals/AddEventModal';
import useEventForm from 'utils/useEventForm';
import Utils from 'shared/EventForm/Utils';
import { FILE_CATEGORIES } from "utils/FileUtils";
import NewActivityForm from 'shared/forms/NewActivity';
import callHistoryActions from 'actions/call_history';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import AddContactModal from 'shared/modals/AddContactModal';
import phoneUtils from "utils/PhoneUtil";
import pbx_config from 'actions/pbx_config';
import PhoneUtil from 'utils/PhoneUtil';
import { DndContext } from '@dnd-kit/core';
import tagsCategoryActions from "actions/tag_categories";
import TextTab from './subcomponents/TextTab';
import textActions from 'actions/text';
import appActions from 'actions/app/app';
import { TextingComponentContext } from 'shared/context/TextingComponentProvider';
import FullScreenModalPopUp from 'shared/FullScreenModalPopUp';
import relationshipsActions from 'actions/relationships';
import { RecordUtils } from 'utils';

const LIMIT = 15;
const PINNED_COMPANY_DESTINATIONS_LIMIT = 3;

const OfficeView = ({ isActive, onClose, phone }) => {
    const [search, setSearch] = useState("");
    const [searchMade, setSearchMade] = useState("");
    const [isSearchResultsVisible, setIsSearchResultsVisible] = useState(false);
    const [page, setPage] = useState(1);
    const dispatch = useDispatch();
    const [isDialDisabled, setIsDialDisabled] = useState(false);
    const [isCompanyExtensionExpanded, setIsCompanyExtensionExpanded] = useState(false);
    const [displayedCompanyDestinations, setDisplayedCompanyDestinations] = useState(false);
    const [isPinnedDestinationsMaxed, setIsPinnedDestinationsMaxed] = useState(false);
    const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
    const [emailInfo, setEmailInfo] = useState({});
    const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);
    const [isEventModalOpen, setIsEventModalOpen] = useState(false);
    const [teamsSearchResults, setTeamsSearchResults] = useState([]);
    const [isLogActivityModalOpen, setIsLogActivityModalOpen] = useState(false);
    const [isAddContactModalOpen, setIsAddContactModalOpen] = useState(false);
    const [unknownNumber, setUnknownNumber] = useState(null);
    const [unknownCnam, setUnknownCnam] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const userAuthTimezone = useSelector((state) => state.auth.timezone);
    const [searchParams] = useSearchParams();
    const { isTextFormDirty, setIsTextFormDirty } = useContext(TextingComponentContext)
    const [confirmAction, setConfirmAction] = useState(null)
    const {
        current_user,
        isSearchingContacts,
        contacts_searched_count,
        contact_lookup,
        viewDestinations,
        isReadingViewDestinations,
        activeIntegration,
        task_labels,
        organizer_id,
        organizer,
        organizer_email,
        isReadingExtensionsTeamsList,
        contactsInHotlistOfficeView,
        accountContacts,
        extensionsTeamsList,
        office_view_teams,
        isReadingOfficeViewTeams,
        selectedTeamsTab,
        //pinnedExtensionsWithUsers,
        pinnedUsers,
        pinsMaxed,
        isReadingPinnedExtensionsWithUsers,
        isReadingExtensionsByTeam,
        extensions,
        calls,
        callState,
        isRinging,
        currentPBX,
        userLeg,
        contactLeg,
        currentCall,
        endedCalls,
        currentCallPhoneNumber,
        userCurrentCallStatus,
        callDirection,
        userCurrentCallDirection,
        actionButtons,
        recentCalls,
        isReadingRecentCalls,
        isReadingRecentCall,
        recentCall,
        selectedTab,
        userCalls,
        currentCallTicker,
        callsRinging,
        callsActive,
        userPhoneCreds,
        isReadingTransferDestinations,
        transferDestinations,
        isUpdatingCallResults,
        currentCallType,
        isTransferringCall,
        isHardPhone,
        isInternalCall,
        listOfTagCategories,
        isGettingListOfTagCategories,
        relationships,
        isReadingRelations
    } = useSelector((state) => {
        const {
            first_name = "",
            last_name = "",
            email: organizer_email,
        } = state.users.userProfile;
        const userPhoneCreds = state.officeView.creds.extension;
        const userCurrentCall = state.officeView.calls[state.officeView.currentCall] 
        const userLeg = userCurrentCall?.legs?.find(l => l.extension === userPhoneCreds);
        const currentCallType = userCurrentCall?.call_type || null;
        const contactLeg = phoneUtils.contactLeg(userCurrentCall, userPhoneCreds);
        const isInternalCall = userCurrentCall?.direction === "internal" ||
            state.officeView.endedCalls[userPhoneCreds]?.direction === "internal" ||
            (state.officeView.endedCalls[userPhoneCreds]?.call_type === "transfer" && state.officeView.endedCalls[userPhoneCreds]?.legs.every(leg => leg.user_id));
        const userCalls = state?.officeView?.extensions[userPhoneCreds]?.reduce((calls, uuid) => {
            const call = state.officeView.calls[uuid];
            const callIDs = phoneUtils.phoneDeviceCallIDs(call, phone, userPhoneCreds);
            const session = phoneUtils.phoneDeviceSession(callIDs.sessionID, phone);
            if (session) {
                call.actionButtons.hold = phone?.current?.phone?.isHeld(session);
                call.actionButtons.mute = phone?.current?.phone?.isMuted(session);
                call.session_id = callIDs.sessionID; //softphone only
            } else {
                delete call.session_id; //hardphone only
            }
            if (call.call_type !== "click2dial" || callIDs.leg) {
                call.name = callIDs.leg.name || phoneUtils.formatPhoneNumber(callIDs.leg.phone);
            }
            call.channel_uuid = callIDs?.userLeg?.channel_uuid
            if ((call.direction === 'outbound' || call.direction === 'internal') && Object.keys(state.officeView.calls).length > 1 && call.status === "ringing" && phoneUtils.isSoftPhone(phone)) {
                //Hold all other call if making outbound call, in conjunction with /reducers/office_view lines 29-32
                phone?.current.holdOtherCalls(callIDs.sessionID);
            }
            calls.push(call)
            return calls;
        }, []) || [];

        const callsRinging = userCalls.some(call => call.status === "ringing");
        const callsActive = userCalls.some(call => call.status === "active");
        const pinsMaxed = state.pbx_config.pinnedExtensionsWithUsers?.length >= 3;
        let pinnedUsers;
        if (state.officeView.selectedTeamsTab === "pinned") {
            pinnedUsers = state.pbx_config?.pinnedExtensionsWithUsers?.map(ext => {
                ext.activeCalls = state?.officeView?.extensions[ext.extension_number]?.filter(uuid => {
                    const call = { ...state.officeView?.calls[uuid] }
                    return call?.company_destination?.substr(0, 1) === '7' || !call?.company_destination;
                })?.map(uuid => {
                    const call = { ...state.officeView?.calls[uuid] }
                    call.name = call?.company_destination?.substr(0, 1) === '7' ? call.destination_name : (call.legs.find(l => !l.extension))?.name || (call.legs.find(l => l.extension !== ext.extension_number))?.name
                    if (state.officeView.currentCallTicker > 0 && call.connected > 0) {
                        call.duration = Math.floor(state.officeView.currentCallTicker - (call.connected || call.start) + (call.drift || 0))
                    }
                    return call;
                }) || []
                return ext;
            });
        } else {
            pinnedUsers = state.pbx_config?.extensionsByTeam?.map(ext => {
                ext.activeCalls = state?.officeView?.extensions[ext.extension_number]?.filter(uuid => {
                    const call = { ...state.officeView?.calls[uuid] }
                    return call?.company_destination?.substr(0, 1) === '7' || !call?.company_destination;
                })?.map(uuid => {
                    const call = { ...state.officeView?.calls[uuid] }
                    call.name = call?.company_destination?.substr(0, 1) === '7' ? call.destination_name : (call.legs.find(l => !l.extension))?.name || (call.legs.find(l => l.extension !== ext.extension_number))?.name
                    if (state.officeView.currentCallTicker > 0 && call.connected > 0) {
                        call.duration = Math.floor(state.officeView.currentCallTicker - (call.connected || call.start) + (call.drift || 0))
                    }
                    return call;
                }) || [];
                return ext;
            });
        }
        return {
            current_user: state.auth,
            viewDestinations: state.pbx_config.viewDestinations,
            isReadingViewDestinations: state.pbx_config.isReadingViewDestinations,
            activeIntegration: state.oauth_integrations.activeIntegration,
            task_labels: state.task.task_type_labels.map(({ name, id }) => ({
                key: id,
                value: id,
                text: name,
            })),
            organizer_id: state.auth.user_id,
            organizer: `${first_name} ${last_name}`,
            organizer_email,
            isReadingExtensionsTeamsList: state.pbx_config.isReadingExtensionsTeamsList,
            contactsInHotlistOfficeView: state.groups.contactsInHotlistOfficeView,
            accountContacts: state.account.contactIds.map(({ first_name, last_name, email, suffix, id }) => ({
                text: `${first_name || ''} ${last_name || ''}${suffix ? `, ${suffix}` : ''}`,
                email,
                key: id,
                value: id
            })),
            extensionsTeamsList: state.pbx_config.extensionsTeamsList,
            office_view_teams: state.user.office_view_teams,
            isReadingOfficeViewTeams: state.user.isReadingOfficeViewTeams,
            selectedTeamsTab: state.officeView.selectedTeamsTab,
            pinnedUsers,
            pinsMaxed,
            isReadingPinnedExtensionsWithUsers: state.pbx_config.isReadingPinnedExtensionsWithUsers,
            isReadingExtensionsByTeam: state.pbx_config.isReadingExtensionsByTeam,
            relationships: state.relationships.relationships,
            isReadingRelations: state.relationships.isReading,

            // View vars
            calls: state.officeView.calls,
            extensions: state.officeView?.extensions,
            // Current call vars
            currentCall: state.officeView?.currentCall,
            userLeg: userLeg,
            userCurrentCallStatus: userCurrentCall?.status,
            contactLeg: contactLeg,
            currentPBX: userCurrentCall?.pbx,
            callState: state.officeView.callState,
            isRinging: state.officeView.callState === "ringing",
            callsRinging,
            callsActive,
            userPhoneCreds,
            // Search state vars
            isSearchingContacts: state.contacts.isSearchingContacts,
            contacts_searched_count: state.contacts.contacts_searched_count,
            contact_lookup: state.officeView.contact_lookup,
            currentCallPhoneNumber: state.officeView.currentCallPhoneNumber,
            callDirection: state.officeView.callDirection,
            userCurrentCallDirection: userCurrentCall?.direction === "internal" ? userLeg?.channel_uuid === userCurrentCall?.uuid && userCurrentCall?.company_destination?.substr(0, 1) !== "7" ? "outbound" : "inbound" : userCurrentCall?.direction,
            endedCalls: state.officeView.endedCalls || {},
            actionButtons: userCurrentCall?.actionButtons,
            userCalls,
            recentCalls: state.call_history.recent_calls,
            isReadingRecentCalls: state.call_history.isReadingRecentCalls,
            recentCall: state.call_history.recent_call,
            isReadingRecentCall: state.call_history.isReadingRecentCall,
            selectedTab: state.officeView.selectedTab,
            currentCallTicker: state.officeView.currentCallTicker,
            isReadingTransferDestinations: state.pbx_config.isReadingTransferDestinations,
            transferDestinations: state.pbx_config.transferDestinations,
            isUpdatingCallResults: state.call_history.isUpdatingCallResult,
            currentCallType,
            isTransferringCall: state.call.isTransferringCall,
            isHardPhone: state.pbx_config.isHardPhone,
            isInternalCall: isInternalCall,
            listOfTagCategories: state?.tag_categories?.listOfTagCategories,
            isGettingListOfTagCategories: state?.tag_categories?.isGettingListOfTagCategories
        }
    });
    const {
        control: eventControl,
        watch: eventWatch,
        isValid: eventIsValid,
        isDirty,
        trigger: eventTrigger,
        setValue: eventSetValue,
        getValues,
        reset,
        isAllowedToModify,
        eventBeingEdited,
        loadEvent,
        handleSubmit: handleSubmitEvent,
        resetField,
    } = useEventForm({
        ...((selectedTab === 0 && contact_lookup?.contact_id) ? { contact_id: contact_lookup.contact_id } : recentCall?.contact_id && { contact_id: recentCall.contact_id })
    });
    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false)
    const {
        control: taskControl,
        watch: taskWatch,
        isValid: taskIsValid,
        isDirty: taskIsDirty,
        trigger: taskTrigger,
        setValue: taskSetValue,
        getValues: taskGetValues,
        clearErrors: taskClearErrors,
        setError: taskSetError,
        reset: taskReset,
        taskBeingEdited,
        loadTask,
        addTask,
        state,
        setState,
        onDelete: onDeleteTask,
        onUpdate: onUpdateTask,
        handleSubmit: handleSubmitTask,
        isAllowedToModify: isTaskAllowedToModify
    } = useTaskForm({
        isContact: false,
        isModal: true,
        open: isTaskModalOpen,
    });
    const pagesOnChange = (id) => {
        if(id === selectedTab) return;
        if(isTextFormDirty){
            setIsConfirmationOpen(true);
            setConfirmAction(() => () => {
                setSelectedTab(id)
            })
        }
    }
    const productPermissions = useSelector(
        (state) => state.subscription.productPermissions
    );
    const hasText = productRestriction(PRODUCT_PERMISSIONS.TEXT_VIEW, productPermissions);
    const pages = [
        { id: 0, icon: "fa-solid fa-phone", onChange: pagesOnChange, isDisableSelecting: isTextFormDirty },
        { id: 1, icon: "fa-solid fa-user-clock", onChange: pagesOnChange, isDisableSelecting: isTextFormDirty },
        { id: 2, icon: "fa-solid fa-comments", disabled: !Boolean(contact_lookup) || isInternalCall || !hasText, onChange:pagesOnChange, isDisableSelecting: isTextFormDirty },
        { id: 3, icon: "fa-solid fa-gear", link: () => { 
            navigate(`/settings/users/${current_user?.user_id}/phone`) 
            dispatch(appActions.onSaveSettingsRoute(location))
        }}
    ];

    const methods = useForm({
        mode: 'onChange',
        defaultValues: {
            dial: "",
        },
        resolver: generateResolver({
            dial: yup.string().minlength(3).required("")
        })
    });

    const { formState: { isValid }, control, watch, setValue, trigger } = methods;

    const {
        control: resultsControl,
        handleSubmit: resultsHandleSubmit,
        formState: { isValid: resultsIsValid, isDirty: resultsIsDirty },
        reset: resultsReset,
        setValue: resultsSetValue,
    } = useForm({
        mode: "onChange",
        defaultValues: {
            call_result: null,
            call_notes: "",
            call_tag: "",
            related_to: null,
            sub_tag: null,
        },
    });

    const { control: transferControl, formState: { isValid: transferValid, isDirty: transferDirty }, getValues: getTransferValues, reset: resetTransfer } = useForm({
        mode: 'onChange',
        defaultValues: {
            phoneNumber: "",
        },
        resolver: generateResolver({
            phoneNumber: VALIDATORS.PHONE_NUMBER()
        })
    });

    const tagsCategoryOptions = useMemo(() => {
        if (!listOfTagCategories?.length) return [];
        return listOfTagCategories?.map?.((category) => {
            return {
                text: category?.category,
                value: category?.id,
                key: category?.id,
                options: category?.tags?.map?.((tag) => ({
                    text: String(tag?.tag),
                    value: tag?.id,
                    key: tag?.id,
                })),
            };
        });
    }, [listOfTagCategories]);

    const dialedNumber = watch("dial");
    const userCallsLength = userCalls.length;
    const isPhoneSystemSupported =
        PhoneUtil.isPhoneSystemSupported(userPhoneCreds);
    const [isCallActivityFormOpen, setIsCallActivityFormOpen] = useState(false);

    const textPhones = useSelector(state => state.text.phones || []);

    const setSelectedTab = async (newTab) => {
        await dispatch(officeView.setSelectedTab('SET_SELECTED_TAB', newTab));
        if (newTab === 1) {
            await dispatch(callHistoryActions.getRecentCalls());
        }
        if (newTab === 2) {
            const contact_phones = contact_lookup?.contact_details?.phone || [];
            const contact_phone = contact_phones.find(option => option.main)?.phone || contact_phones[0]?.phone || undefined;
            dispatch(textActions.getOfficeViewContactInfo(contact_lookup.contact_id));
            const customer_phone = textPhones.length > 0 ? textPhones[0] : '';
            dispatch(textActions.getFilteredMessagesForTextOfficeView({ contact_phone, customer_phone }))
            dispatch(textActions.setConversationBeingViewedInOfficeView({ contact_phone, customer_phone }))
        }
    }

    const onChangeSearch = (_, { value }) => {
        setSearch(value);
        if (!value) {
            setIsSearchResultsVisible(false);
        }
    }

    const searchFunction = async () => {
        try {
            setPage(1);
            setSearchMade(search);
            setIsSearchResultsVisible(true);
            await dispatch(contactsActions.contactSearch({ page: 1, search, limit: LIMIT }));
            await dispatch(officeView.currentCallPhoneNumber('CALL_CURRENT_NUMBER', null));
        } catch (e) {
            console.log(e)
        }
    }

    const onPersonSelect = async (id) => {
        try {
            await dispatch(contactsActions.viewLookup(id));
            await dispatch(officeView.call(callTypes.IDLE_CALL));
            setPage(1);
            setSearch('');
            setIsSearchResultsVisible(false);
            setSearchMade("");
        } catch (error) {
            console.log(error)
        }
    }

    const handleNumberClick = (number) => {
        setValue('dial', number);
        trigger('dial');
        dispatch(officeView.currentCallPhoneNumber('CALL_CURRENT_NUMBER', number));
    }

    const cancelFunction = async () => {
        setSearch("");
        setPage(1);
        setIsSearchResultsVisible(false);
        setSearchMade("");
    }

    const onPageChange = async (_, { activePage }) => {
        await dispatch(contactsActions.contactSearch({ page: activePage, search, limit: LIMIT }));
        setIsSearchResultsVisible(true);
        setPage(activePage);
    }

    const onRemovePerson = async () => {
        await dispatch(contactsActions.removeViewLookup());
        await dispatch(officeView.currentCallPhoneNumber('CALL_CURRENT_NUMBER', null));
        await dispatch(officeView.call(callTypes.IDLE_CALL));
        setPage(1);
        setSearch('');
        setIsSearchResultsVisible(false);
        setSearchMade("");
        setValue('dial', "");
        trigger('dial');
    }

    const onCloseRecentCall = async () => {
        await dispatch(callHistoryActions.removeRecentCall());
        await dispatch(callHistoryActions.getRecentCalls());
    }

    const handleClose = useCallback(() => {
        cancelFunction();
        onClose();
    }, [onClose])

    const toggleIsExpanded = async () => {
        setIsCompanyExtensionExpanded((prevValue) => !prevValue)
        await dispatch(pbxConfigActions.viewDestinations());
    }

    const togglePinned = async (destination_id, pinned) => {
        try {
            await dispatch(pbxConfigActions.setPinned({ destination_id, pinned }));
            await dispatch(pbxConfigActions.viewDestinations());
            Notification.alert(`Company destination ${pinned ? "pinned" : "unpinned"} successfully`, STATUS_TYPES.SUCCESS);
        } catch (error) {
            Notification.alert(`Failed to ${pinned ? "pin" : "unpin"} company destination`, STATUS_TYPES.ERROR);
            console.log(error)
        }
    }

    const togglePinnedTeams = async (destination_id, pinned) => {
        try {
            await dispatch(pbxConfigActions.setPinned({ destination_id, pinned }));
            if (selectedTeamsTab === "pinned") {
                await dispatch(pbxConfigActions.getPinnedExtensionsWithUsers());
            } else {
                await dispatch(pbxConfigActions.getExtensionsByTeam({ team_id: Number(selectedTeamsTab) }));
            }
            Notification.alert(`User ${pinned ? "pinned" : "unpinned"} successfully`, STATUS_TYPES.SUCCESS);
        } catch (error) {
            Notification.alert(`Failed to ${pinned ? "pin" : "unpin"} user`, STATUS_TYPES.ERROR);
            console.log(error)
        }
    }

    const onEmailClick = (name, email) => {
        setIsEmailModalOpen(true);
        setEmailInfo({name: name || null, email: email || null})
    }

    const onTaskClick = () => {
        loadTask({
            contact: selectedTab === 0 ? contact_lookup.contact_id : recentCall?.contact_id
        });
        setIsTaskModalOpen(true);
    }

    const onEventClick = () => {
        loadEvent(null);
        setIsEventModalOpen(true);
    }

    const onAddEvent = async (event) => {
        const id = await dispatch(eventActions.addEvent(Utils.toPayload(event)));
        return id;
    };

    const onAddAttendees = (event_id, params) => {
        return dispatch(
            eventAttendeeActions.addAttendees(params, null, event_id)
        );
    };

    const addAttendees = (event_id, usersToAdd) => {
        let params = {
            payload: usersToAdd,
            integration_id: null,
            access_token: null,
        };
        if (usersToAdd.length > 0) {
            return onAddAttendees(event_id, params);
        }
        return Promise.resolve();
    };

    const onUpload = (file, file_type) => {
        return dispatch(uploadActions.uploadFiles(file, file_type));
    };

    const addAttachments = async (files, event_id) => {
        if (files && files.length > 0) {
            const toUpload = files.filter((file) => file.id === undefined);
            const toCopy = files.filter(file => file.id).map(file => ({
                file_id: file.file_id,
                name: file.name,
                size: file.size
            }));
            const uploadedFiles = await onUpload(toUpload, FILE_CATEGORIES.EVENT);
            const newFiles = toUpload.map((_, idx) => {
                return {
                    name: files[idx].name,
                    file_id: uploadedFiles[idx],
                    size: files[idx].size
                }
            })
            return onAddAttachments(
                [
                    ...newFiles,
                    ...toCopy,
                ],
                current_user.user_id,
                event_id
            );
        }
        return Promise.resolve();
    };

    const onAddAttachments = (attachments, user_id, event_id) => {
        return dispatch(
            eventAttachmentActions.addAttachments(
                attachments,
                { user_id },
                event_id
            )
        );
    };

    const addEvent = async () => {
        const values = getValues();
        const {
            all_day,
            start_date,
            start_time,
            end_date,
            end_time,
            users,
            attachments,
            contacts,
            timezone,
            related_to
        } = values;

        const attendees = [
            ...contacts.map((contact_id) => ({
                accepted: "no",
                contact_id,
                emailed: false
            })),
            ...users.map((user_id) => ({
                accepted: "no",
                user_id,
                emailed: false
            })),
        ];

        // TODO: add recurring event properties
        const payload = {
            complete: false,
            conference_phone: values.phone_number,
            conference_pin: values.pin,
            conference_url: values.conference_line,
            content: values.content,
            content_type: "text/html",
            label: values.label ? values.label : 0,
            location: values.location,
            name: values.name,
            all_day,
            start_date,
            start_time,
            end_date,
            end_time,
            // "recurring_event_id": 0,
            organizer_id,
            organizer,
            organizer_email,
            users: values.users,
            contact_id: values.contacts,
            timezone,
            related_to
        };

        try {
            const { id } = await onAddEvent(payload);
            await addAttendees(id, attendees);
            await addAttachments(attachments, id, "pdf");
            setIsEventModalOpen(false);
            Notification.alert(
                "Successfully created event!",
                STATUS_TYPES.SUCCESS
            );
        } catch (e) {
            console.log(e);
            Notification.alert("Failed to create event", STATUS_TYPES.ERROR);
        }
    };

    const onHotlistClick = async () => {
        try {
            if (contactsInHotlistOfficeView.includes(selectedTab === 0 ? contact_lookup?.contact_id : recentCall?.contacts?.[0]?.contact_id)) {
                await dispatch(groupsActions.removeHotlist(selectedTab === 0 ? contact_lookup?.contact_id : recentCall?.contacts?.[0]?.contact_id));
                await dispatch(groupsActions.checkHotlistOfficeView({ contacts: [selectedTab === 0 ? contact_lookup?.contact_id : recentCall?.contacts?.[0]?.contact_id] }));
                Notification.alert('Successfully removed contact from hotlist!', STATUS_TYPES.SUCCESS, true);
            } else {
                await dispatch(groupsActions.addToHotlist({ contact_id: [selectedTab === 0 ? contact_lookup?.contact_id : recentCall?.contacts?.[0]?.contact_id] }));
                await dispatch(groupsActions.checkHotlistOfficeView({ contacts: [selectedTab === 0 ? contact_lookup?.contact_id : recentCall?.contacts?.[0]?.contact_id] }));
                Notification.alert('Successfully added contact to hotlist!', STATUS_TYPES.SUCCESS, true);
            }
        } catch (error) {
            console.log(error)
            if (contactsInHotlistOfficeView.includes(selectedTab === 0 ? contact_lookup?.contact_id : recentCall?.contacts?.[0]?.contact_id)) {
                Notification.alert('Problem removing contact from hotlist!', STATUS_TYPES.ERROR, true);
            } else {
                Notification.alert('Problem adding contact to hotlist!', STATUS_TYPES.ERROR, true);
            }
        }
    }

    const getTeamsUsers = async (search) => {
        await dispatch(pbxConfigActions.getUsersWithExtensionsAndTeams({ search }));
    }

    const onChangeSelectedTab = async (id) => {
        await dispatch(officeViewActions.changeTeamsTab(id));
    }

    const currentCallChannelUUID = () => {
        return userLeg?.channel_uuid;
    }

    const currentCallUUID = () => {
        return calls[currentCall]?.uuid;
    }

    const currentCallSessionID = () => {
        return calls[currentCall]?.session_id;
    }

    const hangup = () => {
        // phone.current.HangUp(); //May add in future, incase BE endpoint fails
        dispatch(officeView.hangup({ pbx_hostname: currentPBX, channel_uuid: currentCallChannelUUID() }));
        dispatch(officeView.actionButtons('CALL_ACTION_BUTTONS', currentCallUUID(), { hangup: !actionButtons.hangup }));
    }

    const ignore = () => {
        hangup();
        dispatch(officeView.onClosePhoneNotifications("CLOSE_CALL_NOTIFICATIONS", currentCallChannelUUID()));
        dispatch(contactsActions.removeViewLookup());
        dispatch(officeView.call(callTypes.IDLE_CALL));
    }

    const transfer = () => {
        dispatch(officeView.actionButtons('CALL_ACTION_BUTTONS', currentCallUUID(), { transfer: !actionButtons.transfer }));
        resetTransfer();
    }

    const onClickTransfer = (fs_destination) => {
        dispatch(callActions.transfer({
            caller_id_number: contactLeg.phone,
            pbx_hostname: currentPBX,
            channel_uuid: contactLeg.channel_uuid,
            transfer_to: !!fs_destination ? fs_destination : getTransferValues('phoneNumber'),
            caller_id_name: calls[currentCall]?.name
        }, { transfer_user: contactLeg.user_id }));
    }

    const transferToMe = (call) => {
        const contactLeg = call.legs.find(l => l.channel_uuid === call.uuid);
        dispatch(callActions.transfer({
            pbx_hostname: call.pbx,
            channel_uuid: contactLeg.channel_uuid,
            caller_id_number: contactLeg.phone,
            transfer_to: userPhoneCreds,
            caller_id_name: contactLeg.name,
        }));
    }

    const searchTransfer = async (search) => {
        dispatch(pbx_config.transferDestinations({ search }))
    }

    const onHold = () => {
        if (userCallsLength > 1) {
            phone?.current.holdOtherCalls(currentCallSessionID());
        }
        phone.current.phoneHoldButtonPressed(currentCallSessionID());
        dispatch(officeView.actionButtons('CALL_ACTION_BUTTONS', currentCallUUID(), { hold: !actionButtons.hold }));
    }

    const onOutboundDial = () => {
        if (phoneUtils.isSoftPhone(phone)) {
            phone.current.sipCall(dialedNumber);
        }
    }

    const onC2D = () => {
        const { account_id, contact_id, contact_details, account_details, phone, user_id } = contact_lookup || {};
        const destinationPhone = contact_details?.phone?.find?.(({ main }) => main)?.phone
            || account_details?.phone?.find?.(({ main }) => main)?.phone
            || phone
        const destination = PhoneUtil.sanitizePhoneNumber(destinationPhone);
        const payload = isInternalCall ? { destination: currentCallPhoneNumber, to_user_id: user_id } : { contact_id, account_id, destination }
        PhoneUtil.C2D({ payload, dispatch });
    }

    const onRecentCallPhoneClick = () => {
        const person = recentCall?.contacts?.[0] || {};
        const user = recentCall?.users?.[0] || {}
        const { account_id, contact_id, phone: destination } = person;
        const { extension, user_id } = user;
        const payload = recentCall?.contacts?.length > 0 ? { contact_id, account_id, destination } : { destination: extension, to_user_id: user_id }
        PhoneUtil.C2D({ payload, dispatch });
        setSelectedTab(0);
    }

    const onClickToDialList = (payload) => {
        PhoneUtil.C2D({ payload, dispatch });
        setSelectedTab(0);
    }

    const onKeyPress = (number) => {
        phone.current.sipSendDTMF(number);
    }

    const mute = () => {
        phone.current.phoneMuteButtonPressed(currentCallSessionID());
        dispatch(officeView.actionButtons('CALL_ACTION_BUTTONS', currentCallUUID(), { mute: !actionButtons.mute }));
    }

    const answer = () => {
        phone.current.Answer(currentCallChannelUUID());
        dispatch(officeView.actionButtons('CALL_ACTION_BUTTONS', currentCallUUID(), { answer: !actionButtons.answer }));
        dispatch(officeView.onClosePhoneNotifications("CLOSE_CALL_NOTIFICATIONS", currentCallChannelUUID()));
        if (userCallsLength > 1) {
            phone?.current.holdOtherCalls(currentCallSessionID());
        }
    }

    const answerClick2Dial = () => {
        phone.current.Answer(currentCallChannelUUID());
        dispatch(officeView.actionButtons('CALL_ACTION_BUTTONS', currentCallUUID(), { answer: !actionButtons.answer }));
        dispatch(officeView.onClosePhoneNotifications("CLOSE_CALL_NOTIFICATIONS", currentCallChannelUUID()));
        if (userCallsLength > 1) {
            phone?.current.holdOtherCalls(currentCallSessionID());
        }
    }

    const vmDrop = () => {
        dispatch(officeView.actionButtons('CALL_ACTION_BUTTONS', currentCallUUID(), { vmDrop: !actionButtons.vmDrop }));
    }

    const onRecentCallClick = async (call_uuid, user_id) => {
        dispatch(callHistoryActions.getRecentCall(call_uuid, user_id && { user_id })).then(recent => {
            const contact_id = recent?.contacts?.[0]?.contact_id;
            if (contact_id) {
                dispatch(relationshipsActions.getContactRelations({ person_id: contact_id }));
            }
        });
    }

    const onViewMoreClick = () => {
        const { start, end } = DateTimeUtils.getDateRange(
            "this_week",
            DateTimeUtils.getTimezoneCurrentDay(userAuthTimezone),
            DateTimeUtils.DATE_FORMAT,
            "day",
            true,
            userAuthTimezone
        );
        navigate(
            `/call-history?user_id=${current_user?.user_id}&start_ts=${start}&endts=${end}`
        );
        handleClose();
    }
    const onSelectCall = (uuid, phoneNumber) => {
        dispatch({ type: 'CURRENT_CALL', uuid })
        PhoneUtil.loadContactHeader(calls, userPhoneCreds, uuid, dispatch);
        dispatch(officeView.onClosePhoneNotifications("CLOSE_CALL_NOTIFICATIONS", uuid));
        dispatch(officeView.currentCallPhoneNumber('CALL_CURRENT_NUMBER', phoneNumber));
        dispatch(officeView.removeEndedCall('REMOVE_ENDED_CALL', userPhoneCreds));
        resultsSetValue(null, null, { shouldDirty: true }); //To keep save button enabled for call notes, when swapping between calls
    }

    const onAnswerCall = (uuid, channel_uuid, session_id, phoneNumber) => {
        if (userCallsLength > 1) {
            phone?.current.holdOtherCalls(session_id);
        }
        dispatch(officeView.currentCall('CURRENT_CALL', uuid));
        PhoneUtil.loadContactHeader(calls, userPhoneCreds, uuid, dispatch);
        dispatch(officeView.onClosePhoneNotifications("CLOSE_CALL_NOTIFICATIONS", uuid))
        dispatch(officeView.currentCallPhoneNumber('CALL_CURRENT_NUMBER', phoneNumber));
        phone?.current.Answer(channel_uuid);
    }

    const onUnholdCall = (uuid, session_id, phoneNumber) => {
        PhoneUtil.loadContactHeader(calls, userPhoneCreds, uuid, dispatch);
        dispatch(officeView.currentCall('CURRENT_CALL', uuid));
        dispatch(officeView.contactLookup('CONTACT_LOOKUP', uuid));
        dispatch(officeView.currentCallPhoneNumber('CALL_CURRENT_NUMBER', phoneNumber));
        dispatch(officeView.removeEndedCall('REMOVE_ENDED_CALL', userPhoneCreds));
        phone?.current.phoneHoldButtonPressed(session_id);
        resultsSetValue(null, null, { shouldDirty: true }); //To keep save button enabled for call notes, when swapping between calls
        if (userCallsLength > 1) {
            phone?.current.holdOtherCalls(session_id);
        }
    }

    const onIgnoreCall = (uuid, channel_uuid) => {
        // phone?.current.HangUp(); //May add in future, incase BE endpoint fails
        dispatch(officeView.hangup({ pbx_hostname: calls[uuid].pbx, channel_uuid }));
        if (userCallsLength === 1) {
            dispatch(contactsActions.removeViewLookup());
            dispatch(officeView.call(callTypes.IDLE_CALL));
        }
    }
    const onTransferCall = () => {
        console.log("|+|Transfer")
    }

    const getFieldUUID = () => (
        callState === "hangup" ? endedCalls[userPhoneCreds]?.uuid :
            callState === "active" ? currentCall : null
    )

    const onChangeResults = (result) => {
        const uuid = getFieldUUID();
        dispatch(officeView.changeResults('CHANGE_RESULT', uuid, result))
    }

    const onChangeNotes = (notes) => {
        const uuid = getFieldUUID();
        dispatch(officeView.changeNotes('CHANGE_NOTES', uuid, notes))
    }

    const onSaveResults = async (data) => {
        // dbuuid is the uuid stored in the database used for saving the call result
        // the uuid is the freeswitch call_uuid use for determining the primary leg for a call
        // often time they are the same except for transfers
        const dbuuid = endedCalls[userPhoneCreds]?.db_uuid;
        const body = {
            notes: data.call_notes || "",
            result: data.call_result || null,
            tag: data?.sub_tag,
            related_id: data?.related_to || 0
        }
        try {
            await dispatch(callHistoryActions.setUserResult(dbuuid, body));
            resultsReset(null, { keepValues: true });
            Notification.alert("Successfully updated Call Results!", STATUS_TYPES.SUCCESS);
        } catch (error) {
            console.log(error)
            Notification.alert("Failed to update Call Results", STATUS_TYPES.ERROR);
        }
    }

    const onSaveResultRecents = async (data, reset) => {
        const uuid = recentCall?.call_uuid;
        const body = {
            notes: data.call_notes || "",
            result: data.call_result || null,
            tag: data?.sub_tag,
            related_id: data?.related_to || 0
        }
        try {
            await dispatch(callHistoryActions.setUserResult(uuid, body));
            reset(null, { keepValues: true });
            Notification.alert("Successfully updated Call Results!", STATUS_TYPES.SUCCESS);
        } catch (error) {
            console.log(error)
            Notification.alert("Failed to update Call Results", STATUS_TYPES.ERROR);
        }
    }

    const phoneErrors = () => {
        let noMicrophone = "No speakers or microphone enabled on browser.";
        let phoneDisabled = "Soft phone disabled. Please contact your administrator.";
        let error;
        if (phoneUtils.isSoftPhone(phone) && isHardPhone) {
            error = phone?.current.checkNoMedia() ? noMicrophone : false;
        } else if (!phoneUtils.isSoftPhone(phone) && !isHardPhone) {
            error = phoneDisabled;
        } else if (phoneUtils.isSoftPhone(phone) && !isHardPhone) {
            error = phone?.current.checkNoMedia() ? noMicrophone : false;
        } else if (!phoneUtils.isSoftPhone(phone) && isHardPhone) {
            error = phoneDisabled;
        } else {
            error = false;
        }
        return error
    }

    const onMarkVoicemailListened = (call_uuid) => {
        if (!call_uuid) return;
        try {
            dispatch(
                callHistoryActions.setVoicemailListened(
                    null,
                    { listened: true },
                    { call_uuid }
                )
            );
            dispatch(callHistoryActions.getCalls(searchParams));
            Notification.alert(
                "Marked successfully listened",
                STATUS_TYPES.SUCCESS
            );
        } catch (error) {
            Notification.alert("Failed to update", STATUS_TYPES.ERROR);
            console.log(error);
        }
    };
    useEffect(() => {
        if (currentCallPhoneNumber && callDirection !== "inbound" && !callsActive) {
            setValue('dial', currentCallPhoneNumber);
            setIsDialDisabled(false);
            trigger('dial');
            return;
        }
        if (contact_lookup && !callsActive) {
            if (contact_lookup?.contact_id) {
                dispatch(groupsActions.checkHotlistOfficeView({ contacts: [contact_lookup?.contact_id] }));
                if (contact_lookup.account_id) {
                    dispatch(accountActions.readContactIds(contact_lookup.account_id));
                } else {
                    dispatch(accountActions.clearContactIds());
                }
            }
            const number = contact_lookup.contact_id ? (
                contact_lookup.contact_details?.phone?.[0]?.phone || null
            ) : (
                contact_lookup.account_details?.phone?.[0]?.phone || null
            )
            if (number) {
                if (callDirection !== "inbound") {
                    setValue('dial', number);
                    trigger('dial');
                }
                setIsDialDisabled(false);
            } else {
                setValue('dial', "");
            }
        } else {
            setValue('dial', "");
            setIsDialDisabled(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contact_lookup, setValue, trigger, dispatch, currentCallPhoneNumber])

    useEffect(() => {
        if (!isActive) {
            handleClose();
        }
    }, [isActive, handleClose])

    useEffect(() => {
        dispatch(pbxConfigActions.viewDestinations());
        dispatch(oauthActions.getIntegrations({ scopes: 'email', include_disabled: false }));
        dispatch(userActions.getOfficeViewTeams());
        dispatch(tagsCategoryActions.getListOfTagCategories());
    }, [dispatch])

    useEffect(() => {
        const pinnedDestinations = viewDestinations.filter(({ pinned }) => !!pinned);
        const isPinnedDestinationsFull = pinnedDestinations.length >= PINNED_COMPANY_DESTINATIONS_LIMIT;
        setIsPinnedDestinationsMaxed(isPinnedDestinationsFull);
        // no drift because set from client time
        if (isCompanyExtensionExpanded) {
            setDisplayedCompanyDestinations(viewDestinations.map(dest => {
                dest.activeCalls = extensions[dest.fs_destination]?.filter(uuid => {
                    const call = { ...calls[uuid] }
                    return call?.company_destination;
                })?.map(uuid => {
                    const call = { ...calls[uuid] }
                    const userLeg = call.legs.find(leg => leg.user_id);
                    call.name = call.company_destination.substr(0, 1) === '7' && call.legs.length === 1 && userLeg
                        ? userLeg.name
                        : call.direction === "internal"
                            ? (call.legs.find(l => l.channel_uuid === call.uuid)).name
                            : (call.legs.find(l => !l.extension))?.name || userLeg.name;
                    if (currentCallTicker > 0) {
                        call.duration = Math.floor(currentCallTicker - call.start)
                    }
                    return call
                }) || [];
                return dest;
            }));
        } else {
            setDisplayedCompanyDestinations(pinnedDestinations.map(dest => {
                dest.activeCalls = extensions[dest.fs_destination]?.filter(uuid => {
                    const call = { ...calls[uuid] }
                    return call?.company_destination;
                })?.map(uuid => {
                    const call = { ...calls[uuid] }
                    const userLeg = call.legs.find(leg => leg.user_id);
                    call.name = call?.company_destination.substr(0, 1) === '7' && call.legs.length === 1 && userLeg
                        ? userLeg?.name
                        : call.direction === "internal"
                            ? (call.legs.find(l => l.channel_uuid === call.uuid))?.name
                            : (call.legs.find(l => !l.extension))?.name || userLeg?.name;
                    if (currentCallTicker > 0) {
                        call.duration = Math.floor(currentCallTicker - call.start)
                    }
                    return call
                }) || [];
                return dest;
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [viewDestinations, isCompanyExtensionExpanded, calls, currentCallTicker, extensions])

    useEffect(() => {
        if (extensionsTeamsList && extensionsTeamsList?.length > 0) {
            setTeamsSearchResults(extensionsTeamsList)
        } else {
            setTeamsSearchResults([])
        }
    }, [extensionsTeamsList])

    useEffect(() => {
        if (selectedTeamsTab !== "pinned") {
            dispatch(pbxConfigActions.getExtensionsByTeam({ team_id: Number(selectedTeamsTab) }));
        }
        dispatch(pbxConfigActions.getPinnedExtensionsWithUsers());
    }, [selectedTeamsTab, dispatch])

    useEffect(() => {
        if ((contactLeg && userLeg) || (!calls[currentCall]?.ringing_agent && currentCallType === "click2dial")) {
            dispatch(officeView.currentDirection('CALL_DIRECTION', userCurrentCallDirection))
            if (userCurrentCallStatus === "ringing") {
                dispatch(officeView.call(callTypes.RINGING_CALL));
                dispatch(officeView.removeEndedCall('REMOVE_ENDED_CALL', userPhoneCreds));
                if (userCurrentCallDirection === "inbound") {
                    dispatch(officeView.currentCallPhoneNumber('CALL_CURRENT_NUMBER', contactLeg?.phone || contactLeg?.extension));
                }
            }
            if (userCurrentCallStatus === "active") {
                dispatch(officeView.call(callTypes.ACTIVE_CALL));
            }
            if (userCurrentCallStatus === "hangup") {
                dispatch(officeView.call(callTypes.HANGUP_CALL));
            }
            if (userCurrentCallStatus === "ignore") {
                dispatch(officeView.call(callTypes.IGNORE_CALL));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contactLeg, userLeg, userCurrentCallStatus, dispatch])

    useEffect(() => {
        if (contactLeg && userLeg) {
            if (userCurrentCallStatus !== "ringing") {
                return;
            }
            if (userCurrentCallStatus !== "ignore" && (contactLeg.contact_id || contactLeg.account_id)) {
                dispatch(contactsActions.viewLookup(contactLeg?.contact_id ? contactLeg?.contact_id : contactLeg?.account_id))
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userCurrentCallStatus])

    useEffect(() => {
        if (selectedTab === 0) {
            if (contact_lookup) {
                const { phone, name } = contact_lookup;
                const currentCallPhoneNumberAux = phoneUtils.sanitizePhoneNumber(phone);
                setUnknownNumber(currentCallPhoneNumberAux);
                setUnknownCnam(name);
            } else {
                setUnknownNumber(null);
                setUnknownCnam("");
            }
        } else {
            setUnknownNumber(recentCall?.contacts?.[0]?.phone || null)
            setUnknownCnam(recentCall?.contacts?.[0]?.contact_name || "")
        }
    }, [selectedTab, contact_lookup, recentCall])

    useEffect(() => {
        if (currentCall) {
            const call = calls[currentCall];
            if (call) {
                const { user_result, notes, related_id } = call || {};
                const callTag = call?.tags?.[0] || "";
                const [parent_value] = (callTag?.name || "").split("/");
                const parent_id = listOfTagCategories?.find?.(
                    (item) => item?.category === parent_value
                )?.id;
                resultsReset(
                    {
                        call_result: user_result || null,
                        call_notes: notes || "",
                        call_tag: parent_id,
                        sub_tag: callTag?.id,
                        related_to: related_id,
                    },
                    { keepDirty: true }
                );
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentCall]);

    const getRelatedToOptions = (record) => {
        if (!record) {
            return [];
        }
        const { account_id, contact_id, is_customer, relations, pipeline_id, pipeline } = record;
        if (account_id && is_customer) {
            if (!pipeline_id) {
                return [];
            }
            return [
                {
                    key: pipeline_id,
                    value: pipeline_id,
                    text: pipeline,
                    content: <span><Icon className='fas fa-crown' /> {pipeline}</span>
                }
            ]
        }
        if (contact_id) {
            return relations?.map(RecordUtils.getRelationOption) || [];
        }
        return [];
    }

    return (
        <DndContext onDragEnd={(event) => {
            if (!event) {
                return;
            }
            const { active: call, over } = event;
            const source = call.data.current.source;
            const call_uuid = call.data.current.uuid;
            if (!over || !over.id || (source && source === over.id)) {
                return;
            }
            const isDraggingCallToCallBox = over.id === "office-view-call-box";
            if (isDraggingCallToCallBox && source === "additional-line") {
                return onSelectCall(call_uuid, call.data.current.phone);
            }
            if (call.data.current.isInternal) {
                return;
            }
            if (isDraggingCallToCallBox) {
                return transferToMe(call.data.current.call);
            }
            const { target: transfer_to, type } = over.data.current;
            const isTransferringFromActiveCallBox = source === "office-view-call-box";
            const isTransferringToUserCell = type === "office-view-user-cell";
            if (isTransferringFromActiveCallBox) {
                return dispatch(callActions.transfer({
                    pbx_hostname: currentPBX,
                    caller_id_number: call.data.current.phone,
                    channel_uuid: contactLeg.channel_uuid,
                    transfer_to: transfer_to,
                    caller_id_name: calls[currentCall]?.name
                }, isTransferringToUserCell ? { isCell: isTransferringToUserCell, user_id: over.data.current.user_id } : null));
            }
            return dispatch(callActions.transfer({
                pbx_hostname: call.data.current.pbx,
                caller_id_number: call.data.current.phone,
                channel_uuid: call.data.current.channel_uuid,
                transfer_to: transfer_to,
                caller_id_name: call.data.current.caller_id_name
            }, isTransferringToUserCell ? { isCell: isTransferringToUserCell, user_id: over.data.current.user_id } : null));
        }}>
            <div style={{ padding: 30 }}>
                <div style={{ display: 'flex', marginBottom: 10 }}>
                    <Header style={{ flex: 1 }} as={"h1"}>Office View</Header>
                    <Icon className='fa-solid fa-xmark closeIcon' size="big" onClick={handleClose} />
                </div>
                <div style={{ marginBottom: 25 }}>
                    <OfficeViewContainer
                        header={
                            <OfficeViewHeader
                                state={callState}
                                phoneNumber={currentCallPhoneNumber}
                                currentCallTicker={calls[currentCall]?.connected && currentCallTicker > 0 ? currentCallTicker - calls[currentCall]?.connected + (calls[currentCall]?.drift || 0) : 0}
                                callDirection={callDirection}
                                phoneErrors={phoneErrors()}
                                isInternalCall={isInternalCall}
                            />
                        }
                        leftPanel={<OfficeViewLeftPanel pages={pages} selectedTab={selectedTab} setSelectedTab={setSelectedTab} />}
                        rightPanel={
                            selectedTab !== 2 && (
                                <OfficeViewDialPad
                                    control={control}
                                    dialedNumber={dialedNumber}
                                    dialDisabled={
                                        isDialDisabled
                                        || callsRinging
                                        || (!!!currentCallSessionID() && userCallsLength > 0)
                                        || (!phoneUtils.isSoftPhone(phone) && isHardPhone)
                                    }
                                    dialButtonDisabled={!isValid || callsRinging || userPhoneCreds === dialedNumber}
                                    onDial={onOutboundDial}
                                    onKeyPress={onKeyPress}
                                />
                            )
                        }
                    >
                        {selectedTab === 0 && (
                            <OfficeViewPhoneMiddle
                                pages={pages}
                                selectedTab={selectedTab}
                                onNumberClick={handleNumberClick}
                                search={searchMade}
                                isSearchResultsVisible={isSearchResultsVisible}
                                page={page}
                                isSearchingContacts={isSearchingContacts}
                                contacts_searched_count={contacts_searched_count}
                                contact_lookup={contact_lookup}
                                cancelFunction={cancelFunction}
                                searchFunction={searchFunction}
                                onChangeSearch={onChangeSearch}
                                onPersonSelect={onPersonSelect}
                                onPageChange={(onPageChange)}
                                onRemovePerson={onRemovePerson}
                                callState={callState}
                                control={resultsControl}
                                hangup={hangup}
                                // hangupDisabled={hangupDisabled}
                                vmDrop={vmDrop}
                                vmDropDisabled={isRinging || isInternalCall}
                                transfer={transfer}
                                transferDisabled={isRinging || isInternalCall}
                                hold={onHold}
                                holdDisabled={isRinging || !!!currentCallSessionID()}
                                mute={mute}
                                muteDisabled={isRinging || !!!currentCallSessionID()}
                                onSaveDisabled={isRinging || callState === "active" || !resultsIsValid || !resultsIsDirty}
                                isSaveLoading={isUpdatingCallResults}
                                callResultsDisabled={
                                    isRinging ||
                                    (callState === "hangup" && endedCalls[userPhoneCreds]?.direction !== "outbound") ||
                                    (callState === "active" && callDirection !== "outbound")
                                }
                                callTagDisabled={isRinging || isGettingListOfTagCategories}
                                relatedToDisabled={isRinging}
                                currentCallPhoneNumber={currentCallPhoneNumber}
                                duration={endedCalls[userPhoneCreds]?.duration}
                                callRecording={endedCalls[userPhoneCreds]?.callRecording}
                                onEmailClick={onEmailClick}
                                onTaskClick={onTaskClick}
                                onEventClick={onEventClick}
                                onHotlistClick={onHotlistClick}
                                hasIntegration={Object.keys(activeIntegration || {}).length > 0}
                                isInHotlist={contactsInHotlistOfficeView.includes(contact_lookup?.contact_id) || contact_lookup?.contact_details?.hotlist}
                                isLogActivityModalOpen={isLogActivityModalOpen}
                                setIsLogActivityModalOpen={setIsLogActivityModalOpen}
                                isCallActivityFormOpen={isCallActivityFormOpen}
                                setIsCallActivityFormOpen={setIsCallActivityFormOpen}
                                isPhoneSystemSupported={isPhoneSystemSupported}
                                logActivityForm={(contact, emailOnly, isContact, onClose, hideActivitySelection) => {
                                    return (
                                        <NewActivityForm
                                            contact={contact}
                                            emailOnly={emailOnly}
                                            isContact={isContact}
                                            onClose={onClose}
                                            hideActivitySelection={hideActivitySelection}
                                        />
                                    );
                                }}
                                answer={answer}
                                ignore={ignore}
                                callDirection={callDirection}
                                userCurrentCallDirection={userCurrentCallDirection}
                                actionButtons={actionButtons}
                                onNewContactClick={() => setIsAddContactModalOpen(true)}
                                lines={userCalls?.filter(call => call.uuid !== currentCall)}
                                currentTime={currentCallTicker}
                                onSelectCall={onSelectCall}
                                onAnswer={onAnswerCall}
                                onReject={onIgnoreCall}
                                onUnholdCall={onUnholdCall}
                                additionalLineSpace={(() => {
                                    if (userCallsLength <= 2) {
                                        return "";
                                    }
                                    if (userCallsLength > 2 && userCallsLength <= 4) {
                                        return "small";
                                    }
                                    if (userCallsLength > 4 && userCallsLength <= 6) {
                                        return "medium";
                                    }
                                    return "large";
                                })()}
                                onTransferCall={onTransferCall}
                                onChangeResults={onChangeResults}
                                onChangeNotes={onChangeNotes}
                                onSaveResults={resultsHandleSubmit(onSaveResults)}
                                transferControl={transferControl}
                                onClickTransfer={onClickTransfer}
                                transferValid={transferValid}
                                transferDirty={transferDirty}
                                isReadingTransferDestinations={isReadingTransferDestinations}
                                transferDestinations={transferDestinations}
                                searchTransfer={searchTransfer}
                                onClickToDial={onC2D}
                                isClickToDial={currentCallType === "click2dial"}
                                isClickToDialAnswered={currentCallType === "click2dial" && !calls[currentCall]?.ringing_agent}
                                answerClick2Dial={answerClick2Dial}
                                // ignoreDisabled={}
                                answerDisabled={!!!currentCallSessionID() || phoneUtils.isHardPhone(phone)}
                                isTransferringCall={isTransferringCall}
                                callTagOptions={tagsCategoryOptions}
                                isInternalCall={isInternalCall}
                                currentCall={calls[currentCall] || endedCalls[userPhoneCreds]}
                                currentCallUUID={currentCallUUID()}
                                userPhoneCreds={userPhoneCreds}
                                relatedToOptions={getRelatedToOptions(contact_lookup ? {
                                    ...contact_lookup,
                                    pipeline: contact_lookup?.contact_details?.pipeline_stage || contact_lookup?.account_details?.pipeline_stage,
                                    pipeline_id: contact_lookup?.contact_details?.pipeline_id || contact_lookup?.account_details?.pipeline_id,
                                    is_customer: contact_lookup?.account_details?.customer
                                } : null)}
                            />
                        )}
                        {selectedTab === 1 && (
                            <OfficeViewRecents
                                recents={recentCalls}
                                count={recentCalls.length}
                                onRecentCallClick={onRecentCallClick}
                                recentCall={recentCall}
                                onCloseRecentCall={onCloseRecentCall}
                                onEmailClick={onEmailClick}
                                setIsLogActivityModalOpen={setIsLogActivityModalOpen}
                                logActivityForm={(contact, emailOnly, isContact, onClose, hideActivitySelection) => {
                                    return (
                                        <NewActivityForm
                                            contact={contact}
                                            emailOnly={emailOnly}
                                            isContact={isContact}
                                            onClose={onClose}
                                            hideActivitySelection={hideActivitySelection}
                                        />
                                    );
                                }}
                                hasIntegration={Object.keys(activeIntegration || {}).length > 0}
                                onTaskClick={onTaskClick}
                                onHotlistClick={onHotlistClick}
                                isInHotlist={contactsInHotlistOfficeView.includes(recentCall?.contacts?.[0]?.contact_id)}
                                isLogActivityModalOpen={isLogActivityModalOpen}
                                onEventClick={onEventClick}
                                isReadingRecentCalls={isReadingRecentCalls}
                                isReadingRecentCall={isReadingRecentCall || isReadingRelations}
                                onViewMoreClick={onViewMoreClick}
                                onNewContactClick={() => setIsAddContactModalOpen(true)}
                                callResultsDisabled={recentCall?.direction !== "outbound"}
                                onSave={onSaveResultRecents}
                                onMarkVoicemailAsListened={onMarkVoicemailListened}
                                isUpdatingCallResults={isUpdatingCallResults}
                                callTagOptions={tagsCategoryOptions}
                                callTagDisabled={isGettingListOfTagCategories}
                                onClickToDial={onRecentCallPhoneClick}
                                onClickToDialList={onClickToDialList}
                                isPhoneSystemSupported={isPhoneSystemSupported}
                                userPhoneCreds={userPhoneCreds}
                                relatedToOptions={relationships.map(RecordUtils.getRelationOption)}
                                onChangeNotes={onChangeNotes}
                                onChangeResults={onChangeResults}
                                relatedToDisabled={isRinging}
                            />
                        )}
                        {selectedTab === 2 && (
                            <TextTab recipientId={contact_lookup?.contact_id} recipientOptions={contact_lookup?.contact_details?.phone || []} recipientName={contact_lookup?.name} />
                        )}
                    </OfficeViewContainer>
                </div>
                <div>
                    <OfficeViewCompanyDestinations
                        transfer={transferToMe}
                        isExpanded={isCompanyExtensionExpanded}
                        toggleIsExpanded={toggleIsExpanded}
                        companyDestinations={displayedCompanyDestinations}
                        togglePinned={togglePinned}
                        isReadingViewDestinations={isReadingViewDestinations}
                        isPinnedDestinationsMaxed={isPinnedDestinationsMaxed}
                        userPhoneCreds={userPhoneCreds}
                    />
                </div>
                <div style={{ marginTop: 25 }}>
                    <OfficeViewTeams
                        isReadingExtensionsTeamsList={isReadingExtensionsTeamsList}
                        getExtensions={getTeamsUsers}
                        searchResults={teamsSearchResults}
                        teams={office_view_teams}
                        isReadingOfficeViewTeams={isReadingOfficeViewTeams}
                        selectedTeamsTab={selectedTeamsTab}
                        onChangeSelectedTab={onChangeSelectedTab}
                        togglePinnedTeams={togglePinnedTeams}
                        pinnedUsers={pinnedUsers}
                        isReadingUsers={isReadingPinnedExtensionsWithUsers || isReadingExtensionsByTeam}
                        pinsMaxed={pinsMaxed}
                        userPhoneCreds={userPhoneCreds}
                        onClickToDialList={onClickToDialList}
                        onEmailClick={onEmailClick}
                        hasIntegration={Object.keys(activeIntegration || {}).length > 0}
                    />
                </div>
                <SendEmailModal
                    open={isEmailModalOpen}
                    onClose={() => { setIsEmailModalOpen(false); }}
                    contact_id={selectedTab === 0 ? (contact_lookup?.contact_id) : (recentCall?.contact_id)}
                    account_id={selectedTab === 0 ? (contact_lookup?.account_id) : (recentCall?.account_id)}
                    isAccountModal={!(selectedTab === 0 ? (contact_lookup?.contact_id) : (recentCall?.contact_id))}
                    emailInfo={emailInfo}
                />
                <AddTaskModal
                    open={isTaskModalOpen}
                    onClose={() => setIsTaskModalOpen(false)}
                    state={state}
                    control={taskControl}
                    watch={taskWatch}
                    isValid={taskIsValid}
                    isDirty={taskIsDirty}
                    trigger={taskTrigger}
                    setValue={taskSetValue}
                    getValues={taskGetValues}
                    clearErrors={taskClearErrors}
                    setError={taskSetError}
                    reset={taskReset}
                    taskBeingEdited={taskBeingEdited}
                    loadTask={loadTask}
                    addTask={addTask}
                    setState={setState}
                    onDelete={onDeleteTask}
                    onUpdate={onUpdateTask}
                    task_labels={task_labels}
                    organizer_id={organizer_id}
                    organizer={organizer}
                    organizer_email={organizer_email}
                    handleSubmit={handleSubmitTask}
                    onRefresh={() => setIsTaskModalOpen(false)}
                    email={{ body: "", subject: "" }}
                    isAllowedToModify={isTaskAllowedToModify}
                    hiddenContactSelector
                />
                <AddEventModal
                    open={isEventModalOpen}
                    onClose={() => setIsEventModalOpen(false)}
                    onSave={handleSubmitEvent(addEvent)}
                    selected_users={[]}
                    isAllowedToModify={isAllowedToModify}
                    control={eventControl}
                    watch={eventWatch}
                    isValid={eventIsValid}
                    isDirty={isDirty}
                    trigger={eventTrigger}
                    setValue={eventSetValue}
                    getValues={getValues}
                    reset={reset}
                    resetField={resetField}
                    eventBeingEdited={eventBeingEdited}
                    setNotificationContactName={() => { }}
                    accountContacts={accountContacts}
                    currentContact={(selectedTab === 0 && contact_lookup?.contact_id) ? {
                        text: contact_lookup.name,
                        key: contact_lookup.contact_id,
                        value: contact_lookup.contact_id,
                        email: contact_lookup.contact_details?.email || ""
                    } : (selectedTab === 1 && recentCall?.contacts?.[0]?.contact_id) && {
                        text: recentCall?.contacts?.[0]?.name,
                        key: recentCall?.contacts?.[0]?.contact_id,
                        value: recentCall?.contacts?.[0]?.contact_id,
                        email: recentCall?.contacts?.[0]?.email || ""
                    }}
                />
                <Modal open={isAddContactModalOpen} onClose={() => setIsAddContactModalOpen(false)}>
                    <AddContactModal
                        onOpen={() => { return Promise.resolve(); }}
                        onClose={() => setIsAddContactModalOpen(false)}
                        unknownNumber={unknownNumber}
                        unknownCnam={unknownCnam}
                        isRecent={selectedTab === 1}
                        onRecentCallReload={() => {
                            if (recentCall) {
                                onRecentCallClick(recentCall.call_uuid)
                            }
                        }}
                        isOfficeView
                    />
                </Modal>
            </div>
            <FullScreenModalPopUp
                header={"Text will not be saved."}
                subheader={"Are you sure you want to exit?"}
                isOpen={isConfirmationOpen}
                onConfirm={() => {
                    setIsConfirmationOpen(false);
                    confirmAction();
                    setIsTextFormDirty(false);
                }}
                onFormClose={() => setIsConfirmationOpen(false)}
                closeIcon={false}
            />
        </DndContext>
    )
}

export default OfficeView;
